<a [routeOrUrl]="link">{{linkText}}</a>
<span>&nbsp;→</span>
